module.exports = __webpack_public_path__ + "static/media/headphone-mobile-ui.a1788968.mov";